<template>
  <div class="video-discount-item">
    <div class="item-top">
      <img :src="item2.fileCoverPath" alt="" class="item-cover" />
      <div class="item-info">
        <p class="item-title">
          {{ item2.title }}
        </p>
        <div class="item-value">
          <span class="new-value">{{
            item2.activityState == 1 ? item2.activityInfo.activityPriceName : ""
          }}</span>
          <span class="old-value">{{ item2.priceName }}</span>
        </div>
      </div>
    </div>
    <div class="item-bottom">
      <div class="countDown-box">
        距结束 <span>{{ day }}</span
        >天 <span>{{ hour }}</span
        >时 <span>{{ minute }}</span
        >分 <span>{{ second }}</span
        >秒
      </div>
      <div class="item-pv">{{ item2.downloads | numberChange }}下载</div>
    </div>
  </div>
</template>

<script>
import numberHandler from "../../../mixin/numberHandle.js";
import setCountDown from "../../../mixin/setCountDown.js";
export default {
  name: "ShopCenterAdminWebVideoDiscountItem",
  props: {
    item2: {
      type: [Object, String],
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mixins: [numberHandler, setCountDown],
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.video-discount-item {
  margin-bottom: 20px;
  .item-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 71px;
    .item-cover {
      width: 135px;
      height: 71px;
      border-radius: 4px;
    }
    .item-info {
      width: 166px;
      // height: 65px;
      .item-title {
        height: 42px;
        color: #3a3d4b;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        // 两行超出省略
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
      .item-value {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 8px;
        .new-value {
          color: #fe4509;
          font-size: 14px;
          font-weight: 500;
          line-height: 14px; /* 100% */
        }
        .old-value {
          margin-left: 8px;
          color: #b4becd;
          font-size: 12px;
          text-decoration: line-through;
        }
      }
    }
  }
  .item-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 25px;
    margin-top: 10px;
    .countDown-box {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 10px;
      border-radius: 10px;
      background: #fff2ee;
      color: #fe480d;
      font-size: 12px;
      line-height: 12px; /* 100% */
    }
    .item-pv {
      color: #8895a9;
      font-size: 12px;
    }
  }
}
</style>
